import { DashboardLayout } from "@/components";
import { authMiddleware } from "@/middleware";
import BuyerDetails from "@/pages/relations/BuyerDetails";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_market/relations/buyers/$relationId")({
	component: BuyerDetailsRoute,
	loader: authMiddleware,
});

function BuyerDetailsRoute() {
	const { relationId } = Route.useParams();
	return (
		<DashboardLayout>
			<BuyerDetails relationId={relationId} />
		</DashboardLayout>
	);
}
